import styled from '@emotion/styled'
import { SuccessCheckmark } from '@oneToOne/shared/assets/SuccessCheckmark'
import { ActionButton } from '@oneToOne/shared/styles'

export const SchedulingContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--white);
  padding: 48px 16px 16px 16px;
  border-radius: var(--border-radius-md);
  box-shadow: var(--box-shadow);
  overflow: hidden;
`

export const CloseButton = styled(ActionButton)`
  position: absolute;
  top: 6px;
  right: 6px;
`

export const CalendlyContainer = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid var(--gray-6);
  display: flex;
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  position: relative;
`

export const CenterContentContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const LoadingText = styled.p`
  margin-bottom: var(--spacing-32);
  font-size: var(--font-size-sm);
`

export const ScheduledInfoText = styled.p`
  margin-bottom: var(--spacing-32);
  font-size: var(--font-size-md);
`

export const SuccessCheckmarkSVG = styled(SuccessCheckmark)`
  width: 64px;
  height: 64px;
`
